import React from 'react';
import { motion } from 'framer-motion';
import { DeviceMockup } from './DeviceMockup';
export function HeroSection() {
  const scrollToCta = () => {
    document.getElementById('cta-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-navy pt-24 pb-16 md:pt-32 md:pb-24 px-6 overflow-hidden" data-id="element-102">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-103">
        {/* Mobile: Mockup shows on top */}
        <div className="block lg:hidden mb-8" data-id="element-104">
          <DeviceMockup data-id="element-105" />
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-center lg:text-left z-10" data-id="element-106">
          <h1 className="font-heading font-bold text-white text-4xl md:text-5xl lg:text-[48px] leading-tight mb-6" data-id="element-107">
            Como organizar suas finanças em 30 dias (e recuperar o controle do
            seu salário) sem usar planilhas de Excel.
          </h1>
          <p className="font-body text-orange text-xl md:text-[24px] font-medium mb-10 leading-relaxed" data-id="element-108">
            O sistema pragmático para o seu dinheiro parar de desaparecer em
            gastos invisíveis. Resultados reais em 4 semanas.
          </p>
          <button onClick={scrollToCta} className="bg-orange hover:bg-orange-hover text-white font-heading font-bold text-lg md:text-xl py-4 px-8 rounded-lg shadow-lg hover:shadow-xl hover:-translate-y-1 transition-all duration-300 w-full sm:w-auto" data-id="element-109">
            QUERO RECUPERAR MEU DINHEIRO
          </button>
        </motion.div>

        {/* Desktop: Mockup shows on right */}
        <div className="hidden lg:block" data-id="element-110">
          <DeviceMockup data-id="element-111" />
        </div>
      </div>
    </section>;
}